/**
 * JWT payload-claim helpers for SessionProvider.
 *
 * Kept separate from ./jwt.ts (readJwtExpSeconds) so each lib file owns one
 * concern and the existing jwt.test.ts is undisturbed. React-free: callers
 * pass the raw token string. See SessionProvider for the React-side wiring.
 */

export function decodeJwtPayload(
  token: string | null,
): Record<string, any> | null {
  if (!token) return null
  const parts = token.split('.')
  if (parts.length < 2) return null
  try {
    const payload = parts[1]
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padding = (4 - (normalized.length % 4)) % 4
    const padded = normalized.padEnd(normalized.length + padding, '=')
    const decoded = atob(padded)
    return JSON.parse(decoded)
  } catch (err) {
    console.warn('[SessionProvider] Failed to decode JWT payload', err)
    return null
  }
}

export function getActiveWorkspaceIdFromToken(
  token: string | null,
): string | null {
  const payload = decodeJwtPayload(token)
  if (!payload) return null
  return (
    payload.activeWorkspaceId ||
    payload.active_workspace_id ||
    payload.activeTenantId ||
    payload.active_tenant_id ||
    null
  )
}
